// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.H136XFPzM9syCb {
  scroll-margin: 8px;
}
.H136XFPzM9syCb.PfyAazGn_4dXw8 {
  margin: 8px 0;
}
.H136XFPzM9syCb.PfyAazGn_4dXw8:last-child {
  margin: 8px 0 0;
}
.qJv26NWQGVKzI9 {
  color: var(--ds-text, #172b4d);
  font-family: var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  font-display: swap;
  border-radius: 3px;
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 36px;
  height: auto;
  min-height: 36px;
  max-height: 160px;
  margin: 0;
  padding: 8px 12px;
  overflow: hidden;
  overflow-y: auto;
  border: none;
  border-radius: 8px;
  background-color: var(--ds-surface-raised, #ffffff);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  resize: none;
  overflow-wrap: break-word;
}
.qJv26NWQGVKzI9:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
.qJv26NWQGVKzI9:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.qJv26NWQGVKzI9:disabled {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.qJv26NWQGVKzI9[readonly] {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
}
.qJv26NWQGVKzI9.BrUoKjJUdIDcBJ {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.qJv26NWQGVKzI9.BrUoKjJUdIDcBJ:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.qJv26NWQGVKzI9.BrUoKjJUdIDcBJ:focus {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.qJv26NWQGVKzI9.HG4u_pRgi3aE92 {
  width: 100%;
}
.qJv26NWQGVKzI9::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
.qJv26NWQGVKzI9:focus {
  outline: none;
}
.qJv26NWQGVKzI9:hover {
  min-height: 36px;
  max-height: 160px;
  background-color: var(--ds-surface-raised, #ffffff);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
.Y44OETtkQ7R6r5 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  margin-top: 8px;
}
.Y44OETtkQ7R6r5 button {
  margin: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `H136XFPzM9syCb`,
	"hoverGapEnabled": `PfyAazGn_4dXw8`,
	"cardComposer": `qJv26NWQGVKzI9`,
	"input-error": `BrUoKjJUdIDcBJ`,
	"full": `HG4u_pRgi3aE92`,
	"cardComposerSubmit": `Y44OETtkQ7R6r5`
};
export default ___CSS_LOADER_EXPORT___;
